module.exports = __webpack_public_path__ + "static/images/shield-check.a34c8fe7cc6864ca90ef8d6f382e6145.svg";